import loadMap from './advert-gmap';
import '/node_modules/bxslider/dist/jquery.bxslider.min.js';

window.addEventListener('DOMContentLoaded', function() {

    function printView() {
        //$('.epc-container').css("width", "60%");
        $('.main .collapse:not(.in)').each(function (index) {
            $(this).collapse("toggle");
        });
        window.print();
    }

    // $(function () {
    //$("[rel=tooltip]").tooltip({ placement: 'right' });

    var queryString = '&' + (document.location + '?').split('?')[1];
    if (queryString.match(/&printpage=/)) {
        printView();
    }

    let searchParams = new URLSearchParams(window.location.search)

    $.get('/accommodation/propertypanel/' + $("#property-details-container").attr("data-advert-id") + (searchParams.has('printpage') ? '?printpage=true' : ''), function (data) {

        $('#property-details-container').empty().html(data);

        $(".main a.collapsed").removeClass("collapsed");
        $(".main div.collapse").addClass("show");

        if ($('.displayPropertyBanner').length) {
            $('.displayPropertyBanner').bxSlider({
                minSlides: 1,
                maxSlides: 1,
                moveSlides: 1,
                slideWidth: 700,
                pager: true,
                auto: false,
                controls: true,
                autoHover: true,
                prevText: "<i class='material-icons icon-chevron-left'></i>",
                nextText: "<i class='material-icons icon-chevron-right'></i>"
            });
        }

        window.unipolLastResortNamespace.bindToolTips();

        loadMap();

    // });

        $('#modal-virtual-tour').on('show.bs.modal', function (event) {
            // Get the button that triggered the modal
            var button = $(event.relatedTarget);

            // Extract value from the custom data-* attribute
            var titleData = button.data('title');
            var srcData = button.data('src');
            $(this).find('.modal-title span').text(titleData);
            $(this).find('.modal-body iframe').attr('src', srcData);
            $(this).find('.modal-body iframe').attr('data-caption', titleData);
        });

    });

    $(document).on("click", '#btn-book-viewing', function () {
    var advertId = $(this).data("id");

    $.get('/housing/book/' + advertId, function (data) {
        //$('.call-to-action-container').append(data);
        $('#modal-message .modal-body').html(data);
        $('#modal-message .modal-body .header-container').remove();
        $('#modal-message').modal('show');
    });
    });

    $(document).on("click", '#btn-request-viewing', function () {
    var formData = $("#booking-form").serialize();

    $.ajax({
        url: '/housing/bookingform',
        type: "Post",
        data: formData,
        success: function (data, status, XMLHttpRequest) {
            //alert('result');
            $("#booking-form-container").html(data);
        },
        error: function (XMLHttpRequest, status, error) {
            if (error) {
                alert('Sorry. An error occurred: ' + error);
            }
        }
    });
    });

    document.documentElement.addEventListener('DOMContentLoaded', function (event) {
        var $tgt = $('.bx-viewport')[0];
        var tgt = document.querySelector('.bx-viewport');
        tgt.style.height = ""
        tgt.removeAttribute('height');
        tgt.style.removeProperty('height');
        $tgt.css('height', '');
        $tgt.removeAttr('height');

    }, false);
});
